import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { PageUserResponse, UserResponse } from '~/Services/AdminUsers'
import { UserItemData } from '~/Services/UserService.d'

export interface GetUsersParams {
  page?: number
  pageSize?: number
  paging?: boolean
}

export interface UsersReducerStore {
  listUsersData: PageUserResponse | null

  
  updateStatus: 'idle' | 'updating' | 'success' | 'fail'
  updateMessage: string | null

  updatedUser: UserItemData | null
}

const initialState: UsersReducerStore = {
  listUsersData: null,

  updateStatus: 'idle',
  updateMessage: null,

  updatedUser: null,
}

export const UsersSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    getUsersRequest: (state, action: PayloadAction<GetUsersParams>) => {},

    setUsersSuccess: (state, action: PayloadAction<PageUserResponse>) => {
      state.listUsersData = action.payload
    },

    setUsersError: state => {
      state.listUsersData = null
    },
    updateUsersRequest: (state, action: PayloadAction<UserItemData>) => {
      state.updateStatus = 'updating'
      state.updateMessage = null
      state.updatedUser = action.payload
    },

    updateUsersuccess: (state, action: PayloadAction<UserItemData>) => {
      state.updateStatus = 'success'
      state.updateMessage = 'Update success'
      state.updatedUser = action.payload

      if (state.listUsersData?.results) {
        const idx = state.listUsersData.results.findIndex(
          u => u.id === action.payload.id
        )
        if (idx !== -1) {
          state.listUsersData.results[idx] = {
            ...state.listUsersData.results[idx],
            firstname: action.payload.firstname,
            lastname: action.payload.lastname,
          }
        }
      }
    },

    updateUsersError: (state, action: PayloadAction<string>) => {
      state.updateStatus = 'fail'
      state.updateMessage = action.payload
    },

    resetUpdateUser: state => {
      state.updateStatus = 'idle'
      state.updateMessage = null
      state.updatedUser = null
    },
  },
})

export const UsersActions = UsersSlice.actions
export const UsersReducer = UsersSlice.reducer